import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import {
  Tabs,
  MealApproveForm,
  MealApproveButtons,
  MealApproveResult,
  MealApproveAuth
} from 'components/MealApproveList';
import { GiveDeduct } from 'components';
import * as cm_action from 'actions/commons';
import * as sik_action from 'actions/sikdae';

import toastr from 'helpers/toastr';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import { safeHistoryPush } from 'helpers/pathValidator';

class MealApproveList extends Component {
  constructor() {
    super();

    this.state = {
      activeItem: '식대신청 내역',
      openModal: false,
      checkedCount: 0,
      members: [],
      memberIDs: [],
      accepter: null,
      count: 1
    };
  }

  // 식대신청 승인, 승인권한 탭 메뉴 추가
  tabMove = async (name) => {
    this.setState({ activeItem: name });

    if (name === '식대신청 내역') {
      this.sikdaeGroupSearch();
    }
  };

  async componentWillMount() {
    cm.propsInit(this.props);

    //식권 승인 상태
    this.approvalStatus();
    //부서 조회
    this.divisionSearch();

    this.approvalList();

    // 식대 그룹 조회
    await this.sikdaeGroup();
    const beforeAccepter = storage.get('beforeAccepter');
    if (this.state.activeItem === '식대신청 내역') {
      storage.remove('beforeAccepter');
    }
    if (beforeAccepter) {
      this.tabMove('식대신청 승인 권한 관리');
    }
  }

  componentDidMount() {
    cm.mainTitle('식대신청 승인/내역');
  }

  //식권 승인 상태
  approvalStatus = async () => {
    try {
      const { sikAPI } = this.props;
      await sikAPI.mealStatusList();
    } catch (e) {
      console.log('###### divisionSearch : ', e);
    }
  };

  checkAccepter = () => {
    const { list } = this.props;

    if (list) {
      const { accepter } = list.data;

      this.setState({ accepter });
    }
  };

  //부서 search
  divisionSearch = async () => {
    try {
      const { cmAPI } = this.props;
      await cmAPI.divisionList();
    } catch (e) {
      console.log('###### divisionSearch : ', e);
    }
  };

  //확인
  submitForm = (e) => {
    e.preventDefault();
    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }

    const $body = $('.rt-table .rt-thead'),
      $checkBoxes = $body.find('input:checkbox:not([disabled])');

    $checkBoxes.prop('checked', false);

    this.setState({ checkedCount: 0 });
    this.approvalList();
    // this.accepterList();
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  //내역 불러오기
  approvalList = async () => {
    const { date, statusStr, depth, text, groupIdx, policyIdx } = this.props;

    let division;
    if (depth) {
      division = depth.value;
    } else {
      division = null;
    }

    const params = {
      startdate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LLL'),
      enddate: date ? date.eDate : moment().format('LLL'),
      code: statusStr ? statusStr.value : null,
      orgCode: division,
      keyword: text ? text.value : null,
      groupIdx: groupIdx ? groupIdx.value : null,
      policyIdx: policyIdx ? policyIdx.value : null
    };

    try {
      const { sikAPI } = this.props;
      await sikAPI.mealApprovalList(params);
      this.checkAccepter();
    } catch (e) {
      console.log('###### approvaList error : ', e);
    } finally {
    }

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: params
    });
  };

  //체크박스 전체 토글
  selectAll = (e) => {
    let isChecked = e.target.checked;
    const $body = $('.rt-table .rt-tbody'),
      $checkBoxes = $body.find('input:checkbox:not([disabled])');

    setTimeout(
      function() {
        if (isChecked) {
          this.setState({ checkedCount: $checkBoxes.length });
          $checkBoxes.prop('checked', true);
        } else {
          this.setState({ checkedCount: 0 });
          $checkBoxes.prop('checked', false);
        }
      }.bind(this),
      50
    );
  };

  //체크된 인원 세기
  selectEach = () => {
    const $body = $('.rt-table .rt-tbody'),
      $checkBoxes = $body.find('input:checkbox:not([disabled]):checked');

    this.setState({ checkedCount: $checkBoxes.length });
  };

  //모두 승인
  approveAllMeal = () => {
    const { list } = this.props;

    if (list) {
      let ids = [];
      list.data.demand
        .filter((item) => {
          return item.status.value === 'READY';
        })
        .forEach((item) => {
          ids.push(parseInt(item.id));
        });

      if (ids.length > 0) {
        this.setState({ checkedCount: ids.length });
        this.approveMod(ids);
      } else {
        toastr('top-right', 'warning', '승인 대기중인 인원이 없습니다.');
      }
    } else {
      return;
    }
  };

  //선택 승인
  approveSelectedMeal = () => {
    const { checkedCount } = this.state;
    if (checkedCount > 0) {
      const $tableBody = $('.rt-table .rt-tbody');
      let ids = [];

      $tableBody.find('input:checkbox:not([disabled]):checked').each((idx, data) => {
        ids.push(parseInt(data.id));
      });

      this.approveMod(ids);
    } else {
      toastr('top-right', 'warning', '승인할 인원을 선택해주세요.');
    }
  };

  //승인
  approveMod = async (ids) => {
    const demand = {
      demand: {
        id: ids
      }
    };

    try {
      const { sikAPI } = this.props;
      await sikAPI.approveMeal(demand);
      const { approval } = this.props;

      if (approval && approval.status === 201) {
        const { checkedCount } = this.state;
        toastr('top-right', 'success', checkedCount + '명 승인 완료');
        this.setState({ checkedCount: 0 });
        this.approvalList();
      } else {
        toastr('top-right', 'error', '일시적인 오류로 승인을 하지 못했습니다. 다시 시도해주세요.');
      }
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      } else {
        toastr('top-right', 'error', '일시적인 오류로 승인을 하지 못했습니다. 다시 시도해주세요.');
      }
    }
  };

  //반려 모달 열기
  openModal = () => {
    const { checkedCount } = this.state;
    if (checkedCount > 0) {
      const $checked = $('.rt-table .rt-tbody').find('input:checkbox:not([disabled]):checked');
      let names = [],
        ids = [];

      $checked.each((idx, data) => {
        names.push(data.name);
        ids.push(parseInt(data.id));
      });

      this.setState({
        openModal: true,
        members: names,
        memberIDs: ids
      });
    } else {
      toastr('top-right', 'warning', '반려할 인원을 선택해주세요.');
    }
  };

  //반려 모달 닫기
  closeModal = () => this.setState({ openModal: false, members: [], memberIDs: [] });

  //반려
  rejectMod = async (cause) => {
    const { memberIDs } = this.state;

    const demand = {
      demand: {
        id: memberIDs,
        cause: cause
      }
    };

    try {
      const { sikAPI } = this.props;
      await sikAPI.rejectMeal(demand);

      const { rejection } = this.props;
      if (rejection && rejection.status === 200) {
        this.closeModal();

        const { checkedCount } = this.state;
        toastr('top-right', 'success', checkedCount + '명 반려 완료');

        this.approvalList();
      } else {
        toastr('top-right', 'error', '일시적인 오류로 반려를 하지 못했습니다. 다시 시도해주세요.');
      }
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      } else {
        toastr('top-right', 'error', '일시적인 오류로 반려를 하지 못했습니다. 다시 시도해주세요.');
      }
    }
  };

  //식대 그룹 조회
  sikdaeGroup = async () => {
    const { cmAPI } = this.props;

    try {
      await cmAPI.sikdaeGroupList();
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
    } finally {
    }
  };

  // 식권 신청 결재 승인자 내역 불러오기
  accepterList = async (demandIdx) => {
    const { depth, text, auth } = this.props;

    let division;
    if (depth) {
      division = depth.value;
    } else {
      division = null;
    }

    const params = {
      grade: auth ? auth.value : null,
      orgCode: division ? division : null,
      keyword: text ? text.value : null
    };

    try {
      const { sikAPI } = this.props;
      await sikAPI.mealApprovalAccepterList(demandIdx, params);
    } catch (e) {
      console.log('###### accepterList error : ', e);
    }
  };

  //식대그룹 search
  sikdaeGroupSearch = async (gIdx) => {
    const { groupIdx } = this.props;
    if (gIdx) {
      const { cmAPI } = this.props;
      try {
        await cmAPI.sikdaePolicyList(gIdx);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }
    } else if (groupIdx.value !== 0) {
      const { cmAPI } = this.props;

      try {
        //식대정책 조회
        await cmAPI.sikdaePolicyList(groupIdx.value);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }
    }
  };

  //페이지 이동
  movePage = (url, params) => {
    const { history } = this.props;

    safeHistoryPush(history, url);
    storage.set('authApproveInfo', params);
  };

  render() {
    const { activeItem, checkedCount, openModal, members, accepter } = this.state,
      { status, division, list, groupIdx, sikdaeGroup, sikdaePolicy } = this.props,
      formFn = {
        status: status,
        division: division,
        sikdaeGroupVal: groupIdx,
        sikdaeGroupSearch: this.sikdaeGroupSearch,
        accepterList: this.accepterList,
        submitForm: this.submitForm,
        handleEntSubmit: this.handleEntSubmit,
        movePage: this.movePage
      },
      btnFn = {
        list: list,
        approveAllMeal: this.approveAllMeal,
        approveSelectedMeal: this.approveSelectedMeal,
        checkedCount: checkedCount,

        modal: openModal,
        openModal: this.openModal,
        closeModal: this.closeModal,
        members: members,
        rejectMeal: this.rejectMod
      },
      resultFn = {
        list: list,
        selectAll: this.selectAll,
        selectEach: this.selectEach
      };

    const topMenuProps = {
      fn: {
        tabMove: this.tabMove
      },
      tabAuth: accepter
    };
    const beforeAccepter = storage.get('beforeAccepter');

    return (
      <main className="maf" style={{ minWidth: 1650, paddingRight: 20 }}>
        <Tabs topMenuProps={topMenuProps} activeItem={activeItem}>
          {activeItem === '식대신청 내역' ? (
            <Fragment>
              <MealApproveForm formFn={formFn} />
              <MealApproveButtons btnFn={btnFn} />
              <MealApproveResult resultFn={resultFn} />
            </Fragment>
          ) : (
            <MealApproveAuth
              gIdx={beforeAccepter ? beforeAccepter.gIdx : null}
              pIdx={beforeAccepter ? beforeAccepter.pIdx : null}
              sikdaeGroup={sikdaeGroup}
              sikdaePolicy={sikdaePolicy}
              division={division}
              formFn={formFn}
            />
          )}
        </Tabs>
      </main>
    );
  }
}

MealApproveList = connect(
  (state) => ({
    //common function call
    division: state.commons.division,

    //result of form selection
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    statusStr: state.commons.statusStr,
    groupIdx: state.commons.group,
    policyIdx: state.commons.policy,
    sikdaeGroup: state.commons.sikdaeGroup,
    sikdaePolicy: state.commons.sikdaePolicy,
    depth: state.commons.depth,
    text: state.commons.text,
    auth: state.commons.auth,
    //result of meal function call
    status: state.sikdae.mealStatus,
    list: state.sikdae.mealList,
    rejection: state.sikdae.rejectMeal,
    approval: state.sikdae.approveMeal
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        divisionList: cm_action.DivisionList,
        changeExcel: cm_action.ChangeExcel,
        sikdaeGroupList: cm_action.SikdaeGroupList,
        sikdaePolicyList: cm_action.SikdaePolicyList
      },
      dispatch
    ),

    sikAPI: bindActionCreators(
      {
        mealStatusList: sik_action.MealApprovalStatus,
        mealApprovalList: sik_action.MealApprovalList,
        mealApprovalAccepterList: sik_action.MealApprovalAccepterList,
        rejectMeal: sik_action.RejectMeal,
        approveMeal: sik_action.ApproveMeal
      },
      dispatch
    )
  })
)(MealApproveList);

export default MealApproveList;
